import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CTAButton, { CTAButtons } from '../ctaButton/CTAButton';

const BlogFooter = (props) => {
  const { alignment, src, callToAction } = props;

  const componentClasses = classNames('blog-footer', {
    [`align-${alignment}`]: alignment
  });

  return (
    <section className={componentClasses}>
      <div dangerouslySetInnerHTML={{ __html: props[src] }}></div>
      {callToAction ? (
        <CTAButtons callToAction={callToAction} />
      ) : (
        <CTAButton
          type="Onboarding Flow Link"
          text="Start your application"
          webflowRoute="default"
          placement="blog_footer"
        />
      )}
    </section>
  );
};

BlogFooter.propTypes = {
  src: PropTypes.string,
  alignment: PropTypes.oneOf(['left', 'center', 'right']),
  callToAction: CTAButtons.propTypes.callToAction
};

export default BlogFooter;
